import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useAppAuth } from '@contexts/AuthContext';
import AcessoNegado from '@pages/AcessoNegado/Index';

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { role, isAuthenticated, loading } = useAppAuth();
  const { accounts, inProgress } = useMsal();
  const location = useLocation();

  // 1. Considere MSAL "ocupado" (inclusive durante o logout)
  const isMsalBusy = [
    InteractionStatus.Startup,
    InteractionStatus.HandleRedirect,
    InteractionStatus.Login,
    InteractionStatus.AcquireToken,
    InteractionStatus.Logout, // impede redirect durante logout
  ].includes(inProgress);

  if (loading || isMsalBusy) {
    const text = inProgress === InteractionStatus.Logout ? 'Saindo…' : 'Carregando…';
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        {text}
      </div>
    );
  }

  // 2. Se não autenticado, envia para Login (evita redirecionar se já estiver na tela de login)
  if (!isAuthenticated || accounts.length === 0) {
    if (location.pathname !== '/Login') {
      return <Navigate to="/Login" replace state={{ from: location }} />;
    }
    return null;
  }

  // 3. Checa permissão de perfil
  if (allowedRoles.length > 0) {
    const roleUpper = (role ?? '').toUpperCase();
    const isAllowed = allowedRoles
      .map(r => r.toUpperCase())
      .includes(roleUpper);

    // usuário está logado mas sem o perfil necessário → exibe AcessoNegado
    if (!isAllowed) {
      return <AcessoNegado />;
    }
  }

  // 4. Está logado e (se aplicável) autorizado → renderiza a rota filha
  return <Outlet />;
};

export default ProtectedRoute;